// authedFetch — wrapper that handles cookie-based session credentials and
// the CSRF double-submit echo for state-changing requests.
//
// Reads `csrf_token` cookie via document.cookie (the cookie is intentionally
// non-HttpOnly so the SPA can echo it back as the X-CSRF-Token header on
// every POST/PUT/DELETE/PATCH). Browser auto-attaches `access_token` and
// `csrf_token` cookies; cross-origin attacker pages CANNOT read either,
// cannot manufacture a matching X-CSRF-Token header — backend 403.
//
// GET / HEAD / OPTIONS skip the header attach (idempotent reads).
// Always sends `credentials: "include"` so cookies flow.
//
// Use for all authenticated calls AFTER login. Login / register / forgot
// flows still use raw fetch since there's no session yet.

const CSRF_HEADER = "X-CSRF-Token";
const CSRF_COOKIE = "csrf_token";
const CSRF_EXEMPT = new Set(["GET", "HEAD", "OPTIONS"]);

function readCookie(name) {
  if (typeof document === "undefined") return "";
  const prefix = name + "=";
  const found = document.cookie.split("; ").find(c => c.startsWith(prefix));
  return found ? found.slice(prefix.length) : "";
}

export async function authedFetch(url, opts = {}) {
  const method = (opts.method || "GET").toUpperCase();
  const headers = { ...(opts.headers || {}) };
  if (!CSRF_EXEMPT.has(method)) {
    const csrf = readCookie(CSRF_COOKIE);
    if (csrf) headers[CSRF_HEADER] = csrf;
  }
  return fetch(url, { ...opts, credentials: "include", headers });
}
